import styled from '@emotion/styled'

export const Title = styled.div`
  margin-right: 12px;
  margin-bottom: 0;
  color: #141323;
  font-weight: 600;
  font-size: 19px;
  line-height: 32px;
`
